import { gql } from "@apollo/client"
import { QueryCompanyArgs, PaymentsSettings } from "@oysterhr/schema"
import { useQuery, UseQueryOptions } from "@oysterhr/core"

export const QUERY = gql`
  query CompanyPaymentSettingsBadges($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentsSettings {
        restricted
        flaggedAsFraudster
        badDebtCategory
      }
    }
  }
`

type QueryResponse = {
  company: {
    paymentsSettings: Pick<
      PaymentsSettings,
      "restricted" | "flaggedAsFraudster" | "badDebtCategory"
    >
  }
  loading: boolean
}

export const useCompanyPaymentSettingsBadges = (
  options: UseQueryOptions<QueryResponse, QueryCompanyArgs>,
) => {
  const { data, loading } = useQuery<QueryResponse, QueryCompanyArgs>(QUERY, { ...options })

  return {
    paymentsSettings: data?.company?.paymentsSettings,
    loading,
  }
}
